import React from 'react';
import BoardCard from '../boards/BoardCard';

const BoardGrid = ({ boards, onBoardSelect }) => {
  // Sort boards: featured first, then by name
  const sortedBoards = [...(boards || [])].sort((a, b) => {
    if (a.is_featured && !b.is_featured) return -1;
    if (!a.is_featured && b.is_featured) return 1;
    return (a.name || '').localeCompare(b.name || '');
  });

  if (!boards || boards.length === 0) {
    return (
      <div className="text-center py-12 bg-white rounded-xl border-2 border-slate-900 shadow-retro p-8">
        <svg className="mx-auto h-16 w-16 text-slate-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
        </svg>
        <h3 className="mt-4 text-lg font-bold text-slate-900">No boards available</h3>
        <p className="mt-2 text-sm text-slate-600">
          There are no climbing boards configured for your gym yet.
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
      {sortedBoards.map((board) => (
        <BoardCard
          key={board.id}
          board={board}
          onReserve={onBoardSelect}
          showReserveButton={true}
          showViewButton={false}
        />
      ))}
    </div>
  );
};

export default BoardGrid;
